export var name = 'sockets';
